export default "__VITE_ASSET__a1w0BT5j__"